export const AUTH_SUCCESS = "user/auth/fulfilled";
export const AUTH_FAIL = "user/auth/rejected";
export const LOGIN_USER_PENDING = "user/loginuser/pending";
export const LOGIN_USER_FULFILLED = "user/loginuser/fulfilled";
export const LOGIN_USER_REJECTED = "user/loginuser/rejected";
export const LOAD_USER_FULFILLED = "user/loaduser/fulfilled";
export const LOAD_USER_REJECTED = "user/loaduser/rejected";
